import { render, staticRenderFns } from "./SeasonTicketDetails.vue?vue&type=template&id=3b97da04&"
import script from "./SeasonTicketDetails.vue?vue&type=script&lang=js&"
export * from "./SeasonTicketDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports